import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import { CustomerDocumentsResponse } from "@/core/customers/entities/CustomerDocuments";
import CustomerDocumentsRepository from "@/core/customers/repositories/CustomerDocumentsRepository";

export default class GetCustomerDocumentsUseCase {
  constructor(
    private readonly customerDocumentsRepository: CustomerDocumentsRepository
  ) {}

  /**
   * Executes the get customer documents use case.
   *
   * @param businessKey - The business key of the customer
   * @returns A promise resolving with CustomerDocumentsResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(businessKey: string): Promise<CustomerDocumentsResponse> {
    if (!businessKey || businessKey.trim() === "") {
      const exception: Exception<unknown, DefaultExceptionTypes> = {
        type: DefaultExceptionTypes.BAD_REQUEST,
        message: "Business key is required",
      };
      throw exception;
    }

    try {
      return await this.customerDocumentsRepository.getCustomerDocuments(
        businessKey
      );
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}

